import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { registerSW } from "virtual:pwa-register";
import App from "./App.js";
import "./index.css";

registerSW({ immediate: true });

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error('Falta el elemento raíz "#root"');
createRoot(rootEl).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
